import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'story-footer',
    template: ` <ng-content /> `,
    imports: [CommonModule],
})
export class StoryFooterComponent {}
